module.exports = __webpack_public_path__ + "static/media/icon-manager.3903345c.svg";